import React, { useCallback } from "react";

import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { faFileCsv } from "@fortawesome/pro-solid-svg-icons/faFileCsv";
import { faList } from "@fortawesome/pro-solid-svg-icons/faList";
import { faSitemap } from "@fortawesome/pro-solid-svg-icons/faSitemap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import InfoBlockWithIcon from "@app/component/typography/InfoBlockWithIcon";
import layout from "@app/styles/layout";

import importsAnalytics from "../importsAnalytics";

import styles from "./InfoLinks.module.scss";

interface Props {}

const InfoLinks: React.FC<Props> = () => {
  const intl = useIntl();

  const handleDataOrganization = useCallback(
    () => importsAnalytics.clicked(["Click", "Data Organization in MMC"]),
    []
  );
  const handleImportInstructions = useCallback(
    () => importsAnalytics.clicked(["Click", "Import instructions"]),
    []
  );
  const handleDownloadSampleFile = useCallback(
    () => importsAnalytics.clicked(["Click", "Download sample file"]),
    []
  );

  return (
    <Row gutter={layout.spacerXL}>
      <Col sm={{ span: 12 }} xl={{ span: 24 }}>
        <InfoBlockWithIcon
          action={
            <Button
              className={styles.infoLink}
              href="https://support.mapmycustomers.com/hc/en-us/articles/1500003935522-How-is-Map-My-Customers-data-organized-"
              onClick={handleDataOrganization}
              rightIcon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
              target="_blank"
              type="link"
            >
              {intl.formatMessage({
                id: "imports.home.infoLinks.learnAbout.action",
                defaultMessage: "Data Organization in MMC",
                description: "Text of first get started link",
              })}
            </Button>
          }
          icon={faSitemap}
          iconColor="green"
          subTitle={intl.formatMessage({
            id: "imports.home.infoLinks.learnAbout.description",
            defaultMessage: "Discover how Companies, People, Deals and Activities work together",
            description: "Sub Title of first item of get started section",
          })}
          title={intl.formatMessage({
            id: "imports.home.infoLinks.learnAbout",
            defaultMessage: "Learn about data in Map My Customers",
            description: "Title of first item of get started section",
          })}
        />
      </Col>
      <Col sm={{ span: 12 }} xl={{ span: 24 }}>
        <InfoBlockWithIcon
          action={
            <Button
              className={styles.infoLink}
              href="https://support.mapmycustomers.com/hc/en-us/articles/360047721513-Importing-data-into-Map-My-Customers-by-spreadsheet"
              onClick={handleImportInstructions}
              rightIcon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
              target="_blank"
              type="link"
            >
              {intl.formatMessage({
                id: "imports.home.infoLinks.exploreImport.action",
                defaultMessage: "Import instructions",
                description: "Text of second get started link",
              })}
            </Button>
          }
          icon={faList}
          iconColor="yellow"
          subTitle={intl.formatMessage({
            id: "imports.home.infoLinks.exploreImport.description",
            defaultMessage:
              "Learn about mandatory fields and helpful formatting tips for your spreadsheet",
            description: "Sub Title of second item of get started section",
          })}
          title={intl.formatMessage({
            id: "imports.home.infoLinks.exploreImport",
            defaultMessage: "Explore our import instructions",
            description: "Title of second item of get started section",
          })}
        />
      </Col>
      <Col sm={{ span: 12 }} xl={{ span: 24 }}>
        <InfoBlockWithIcon
          action={
            <Button
              className={styles.infoLink}
              href="https://support.mapmycustomers.com/hc/en-us/articles/1500003938522-Import-Sample-File"
              onClick={handleDownloadSampleFile}
              rightIcon={<FontAwesomeIcon icon={faDownload} />}
              target="_blank"
              type="link"
            >
              {intl.formatMessage({
                id: "imports.home.infoLinks.sampleFile.action",
                defaultMessage: "Download sample file",
                description: "Text of third get started link",
              })}
            </Button>
          }
          className={styles.lastInfoBlock}
          icon={faFileCsv}
          iconColor="blue"
          subTitle={intl.formatMessage({
            id: "imports.home.infoLinks.sampleFile.description",
            defaultMessage:
              "Download this sample file to see exactly how to organize files for each record type",
            description: "Sub Title of third item of get started section",
          })}
          title={intl.formatMessage({
            id: "imports.home.infoLinks.sampleFile",
            defaultMessage: "Use our sample file to get started ",
            description: "Title of third item of get started section",
          })}
        />
      </Col>
    </Row>
  );
};

export default InfoLinks;
